import styled from "@emotion/styled";
import { isObjectEmpty, saveMap, translateOrderType } from "data/functions";
import React, { useState } from "react";

import { AllInbox, Construction } from "@mui/icons-material/";
import {
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import { GetData } from "contexts/DataContext";
import { constants } from "data/globals";
import { ParamRow } from "./OrderParams";

const TableCell = styled(MuiTableCell)`
  padding: 4px;
`;

export function ProfileTable(props) {
  const [tabValue, setTabValue] = useState(() => {
    if (!isObjectEmpty(props?.docItem?.operations)) return "operations";
    else return "parts";
  });
  const { dataObj } = GetData();
  React.useEffect(() => {
    setTabValue(() => {
      if (!isObjectEmpty(props?.docItem?.operations)) return "operations";
      else return "parts";
    });
  }, [props?.docItem]);

  return (
    <React.Fragment>
      {(!isObjectEmpty(props?.docItem?.operations) ||
        !isObjectEmpty(props?.docItem?.parts)) && (
        <React.Fragment>
          <Paper
            sx={{
              background: "transparent",
              marginTop: 3,
              overflow: "auto",
              scrollbarWidth: "thin",
            }}
          >
            <Table
              size={dataObj?.deviceWidth?.isMobile ? "small" : undefined}
              stickyHeader
              sx={{
                // padding: dataObj?.deviceWidth?.isMobile ? "0.4rem" : undefined,
                padding: "18px 0",
                width: "100%",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Название</TableCell>
                  <TableCell align="center">шт.</TableCell>
                  <TableCell align="center">Всего</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableItemRow
                  array={props?.docItem?.operations}
                  title="Услуги"
                />
                <TableItemRow
                  array={props?.docItem?.parts}
                  currency={props?.docItem?.currencyName}
                  title="Товары"
                />
                {parseInt(props?.docItem?.docSum?.total) > 0 &&
                  translateOrderType(props?.docItem?.type) !==
                    constants.ruTypeZR && (
                    <React.Fragment>
                      <TableRow sx={{ height: "12px" }}></TableRow>
                      <TableRow>
                        <TableCell />
                        <TableCell
                          align="center"
                          // colSpan={1}
                          sx={{
                            lineHeight: "1",
                            paddingTop: "6px !important",
                          }}
                        >
                          Итого
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            lineHeight: "1",
                            paddingTop: "6px !important",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {props?.docItem?.docSum?.total +
                            (props?.docItem?.currencyName
                              ? " " + props?.docItem?.currencyName
                              : " руб.")}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  )}
              </TableBody>
            </Table>
          </Paper>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

function TableItemRow(props) {
  if (isObjectEmpty(props?.array)) return;
  return (
    <React.Fragment>
      <TableRow>
        <TableCell
          colSpan={3}
          sx={{ lineHeight: "1", paddingTop: "8px !important" }}
        >
          {props?.title}
        </TableCell>
      </TableRow>
      {saveMap(props?.array).map((item, index) => (
        <TableRow key={index}>
          <TableCell sx={{ padding: " 0 12px !important" }}>
            {item.name}
          </TableCell>
          <TableCell align="center">{item.count}</TableCell>
          <TableCell
            align="center"
            sx={{
              lineHeight: "1",
              padding: "0px !important",
              whiteSpace: "nowrap",
            }}
          >
            {item.discount > 0 ? (
              <div>
                {item.sum + (props?.currency ? " " + props?.currency : " руб.")}
                <br />
                <sub>
                  <strike>{item.sum + item.discount}</strike>
                  {props?.currency ? " " + props?.currency : " руб."}
                </sub>
              </div>
            ) : (
              item.sum + (props?.currency ? " " + props?.currency : " руб.")
            )}
          </TableCell>
        </TableRow>
      ))}
    </React.Fragment>
  );
}
